import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { CommonStepProgressbarComponent } from './common-step-progressbar/common-step-progressbar.component';

@Component({
  selector: 'app-common-import',
  templateUrl: './common-import.component.html',
  styleUrls: ['./common-import.component.scss']
})
export class CommonImportComponent implements OnInit {
 @Output() stepChanged = new EventEmitter<number>();
 @Output() checkValidation = new EventEmitter<any>();
 @Output() lastButtonClicked = new EventEmitter<number>();

 @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) container: ViewContainerRef;
  @ViewChild(CommonStepProgressbarComponent) commonStepProgressbarComponent: CommonStepProgressbarComponent;


 @Input() steps: string[] = []
 @Input() activeStep = 1;
 flexHeight
 @Input() data:any ={}

  onStepChange(step: number): void {
   this.activeStep = this.data.step=  step;
   this.stepChanged.emit(this.data);
  }
    onNext(step: number) {
      this.checkValidation.emit(step)
    }
    clickOnNext(){
      this.commonStepProgressbarComponent.onNextClick()
    }
  constructor(public commonService      : CommonService,) {}
  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res =>{
      this.flexHeight = `calc(100vh - 21rem - ${res}px)`
  })
  }
  newImport(nextId:number){
    setTimeout(() => {
      this.commonStepProgressbarComponent.currentActive = nextId
      this.commonStepProgressbarComponent. onNextClick();
      this.lastClicked(nextId)
      }, 500);
  }
  lastClicked(nextId){
    this.lastButtonClicked.emit(nextId)
  }
}
